export enum DateFormat {
  HOUR_24 = '24_HOUR',
  HOUR_12 = '12_HOUR',
}
